"use client";

export interface EditorExportModalSlide {
  name: string;
  url: string;
}

export interface EditorExportModalProps {
  open: boolean;
  onClose: () => void;
  generating: boolean;
  generatedSlides: EditorExportModalSlide[] | null;
  downloading: boolean;
  onDownloadAll: () => void;
  enabledCount: number;
  watermarked: boolean;
  onWatermarkNoteClick: () => void;
}

export default function EditorExportModal({
  open, onClose, generating, generatedSlides, downloading, onDownloadAll,
  enabledCount, watermarked, onWatermarkNoteClick,
}: EditorExportModalProps) {
  if (!open) return null;
  const total = generatedSlides?.length ?? 0;

  return (
    <div className="car-modal-backdrop" onClick={onClose}>
      <div className="car-modal car-modal--wide" onClick={(e) => e.stopPropagation()}>
        <div className="ced-modal-head">
          <h3 className="car-modal-title">Export carousel</h3>
          <button type="button" className="ced-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        {generating || !generatedSlides ? (
          <p className="car-generating-note">Generating your carousel…</p>
        ) : (
          <>
            <div className="ced-export-grid">
              {generatedSlides.map((slide) => (
                <div key={slide.name} className="ced-export-thumb">
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img src={slide.url} alt={slide.name} />
                </div>
              ))}
            </div>
            <p className="car-export-summary">{total} slides · {enabledCount} bird{enabledCount === 1 ? "" : "s"}</p>

            <button type="button" className="car-generate-btn" onClick={onDownloadAll} disabled={downloading} style={{ width: "100%" }}>
              {downloading ? "Zipping…" : "⬇ Download all slides"}
            </button>

            {watermarked && (
              <button type="button" className="car-watermark-link" onClick={onWatermarkNoteClick}>
                Remove the LiferRadar.com watermark
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
